// src/pages/PlaylistDetail.js
import React, { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { PlaylistContext } from '../context/PlaylistContext';
import AudioPlayer from '../components/AudioPlayer';

const PlaylistDetail = () => {
  const { playlistId } = useParams();
  const { playlists } = useContext(PlaylistContext);
  const playlist = playlists.find(pl => pl.name === playlistId);

  if (!playlist) {
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>Playlist Not Found</h1>
        <p>No playlist exists with the name "{playlistId}"</p>
      </div>
    );
  }

  // The tracks here are the saved sentences with their audioSrc and targetSentence properties.
  const tracks = playlist.sentences; 

  return (
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <AudioPlayer playlistName={playlist.name} tracks={tracks} pauseDuration={3000} />
    </div>
  );
};

export default PlaylistDetail;
